/**
 * Op-codes для всех контрактов.
 * Должны совпадать с константами в .tact файлах.
 *
 * Используем стандартные crc32 хеши имени сообщения по convention TON.
 * В Tact сообщения с пометкой `message(0x...)` фиксируют op-code явно.
 */

// Factory
export const OP_DEPLOY_TOKEN = 0x44504c4e; // "DPLN"
// CC-015 PR-D1 relay — backend sends this to the factory; the factory
// then sends `Migrate` to the curve on behalf of itself, satisfying the
// curve's `sender() == factoryAddr` gate. Direct Migrate from a hot
// wallet would be rejected, so MigrateToken is the only path that lets
// the off-chain orchestrator actually trigger graduation.
export const OP_MIGRATE_TOKEN = 0x4d475452; // "MGTR"
export const OP_FACTORY_SET_ROYALTY_RECEIVER = 0x46534552; // "FSER" — bot → factory: rotate curve's royaltyReceiver

// Bonding Curve
export const OP_INIT_CURVE = 0x49435256; // "ICRV"
export const OP_BUY = 0x42554b4e; // "BUKN"
export const OP_SELL = 0x53454c4c; // "SELL"
export const OP_CLAIM_FEES = 0x434c464d; // "CLFM"
export const OP_MIGRATE = 0x4d494752; // "MIGR"
export const OP_SET_ROYALTY_RECEIVER = 0x53455452; // "SETR" — factory → curve (internal)

// Events (out-messages emitted by contracts; indexer parses these)
export const EVENT_TOKEN_DEPLOYED = 0x544b444c; // "TKDL"
export const EVENT_BUY_SUCCESS = 0x42595357; // "BYSW"
export const EVENT_SELL_SUCCESS = 0x534c5357; // "SLSW"
export const EVENT_MIGRATION_READY = 0x4d474f4b; // "MGOK"

// Standard TEP-74 jetton ops (для совместимости)
export const OP_JETTON_TRANSFER = 0x0f8a7ea5;
export const OP_JETTON_TRANSFER_NOTIFICATION = 0x7362d09c;
export const OP_JETTON_INTERNAL_TRANSFER = 0x178d4519;
export const OP_JETTON_BURN = 0x595f07bc;
export const OP_JETTON_EXCESSES = 0xd53276db;
